import { render, staticRenderFns } from "./ProfileSuggestedPages.vue?vue&type=template&id=4c6d1148&"
import script from "./ProfileSuggestedPages.vue?vue&type=script&lang=js&"
export * from "./ProfileSuggestedPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports